import { inject, injectable } from 'tsyringe';
import { DatasourcePresetsCollection } from './Presets/PresetsCollection';

@injectable()
export class NotificationPresetService {
    public constructor(@inject(DatasourcePresetsCollection) private readonly invoicePresets: DatasourcePresetsCollection) {}

    public async getPresets(datasource: string | undefined = undefined) {
        const presetBuilders = await this.invoicePresets.getBuilders(datasource);
        return presetBuilders.flatMap((b) => b.getPresets());
    }
}
